<template>
    <div id="view-sms" class="modal fade" tabindex="-1" role="dialog"
         style="display: none;">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title font-normal" id="modalTitle">SMS Message <span class="label label-info">{{sms.status}}</span></h4>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                </div>
                <div class="modal-body full-height-scroll limit-modal-height">
                    <div class="form">

                        <div class="form-group">
                            <span class="font-weight-bold">Mobile</span>
                            <p>{{sms.to}}</p>
                        </div>

                        <div class="form-group">
                            <span class="font-weight-bold">Message</span>
                            <p>
                                {{sms.body}}
                            </p>
                        </div>

                        <div class="form-group">
                            <p>
                                Created at {{sms.created_at}}. {{sms.credits}} sms {{sms.credits === 1 ? 'credit' : 'credits'}} used.
                            </p>
                        </div>

                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default waves-effect" data-dismiss="modal"
                            @click.prevent="hideSmsForm">
                        Close
                    </button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "view-sms",

        props: ["sms", "show"],

        watch: {

            show: function () {
                if (this.show) {
                    $("#view-sms").modal("show");
                }
            }

        },

        methods: {
            hideSmsForm () {
                this.$emit("close-sms-form");
            }
        }

    };
</script>

<style scoped>

</style>
